module.exports = __webpack_public_path__ + "static/media/icon-not-visible.cb2017fd.svg";